import { Box, styled } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import {
  CalendarJobTypeLeftColumnLabel,
  getCalendarJobTypeLeftColumnTitle,
} from '../../helpers/get-calendar-job-type-left-column-label';

type CalendarJobTypeLeftColumnLabelProps = {
  label: CalendarJobTypeLeftColumnLabel;
  jobTypeName: string;
};

export const CalendarJobTypeLeftColumnLabelView = ({
  label,
  jobTypeName,
}: CalendarJobTypeLeftColumnLabelProps) => {
  const title = getCalendarJobTypeLeftColumnTitle(label, jobTypeName);

  return (
    <LabelRoot title={title}>
      {label.variant === 'own-company' ? (
        <HeaderLine>
          <BoldInlineText>{label.branchOfficeName}</BoldInlineText>
          {`-${label.departmentName}`}
        </HeaderLine>
      ) : (
        <CompanyNameLine>{label.companyName}</CompanyNameLine>
      )}
      <JobTypeLine>{jobTypeName}</JobTypeLine>
    </LabelRoot>
  );
};

const LabelRoot = styled(Box)(({ theme }) => ({
  width: '14vw',
  padding: theme.spacing(2, 2, 2, 0),
  overflow: 'hidden',
  flex: 'none',
  minWidth: 0,
}));

const calendarLeftColumnBaseText = (theme: Theme) => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.lwBlack[100],
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

const CompanyNameLine = styled(Box)(({ theme }) => ({
  ...calendarLeftColumnBaseText(theme),
  fontWeight: 700,
  fontVariationSettings: '"wght" 700',
}));

const HeaderLine = styled(Box)(({ theme }) => ({
  ...calendarLeftColumnBaseText(theme),
  fontWeight: 500,
  fontVariationSettings: '"wght" 500',
}));

const JobTypeLine = styled(Box)(({ theme }) => ({
  ...calendarLeftColumnBaseText(theme),
  fontWeight: 500,
  fontVariationSettings: '"wght" 500',
}));

const BoldInlineText = styled('span')({
  fontWeight: 700,
  fontVariationSettings: '"wght" 700',
});
